module.exports = __webpack_public_path__ + "img/ebay-card.70626b3c.svg";